import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UigDeliveryDetailsService {

  constructor(
    protected httpClient: HttpClient,
    private endpoints: OccEndpointsService
  ) {}

  getDeliveryDetails(userId: string): Observable<Object> {
    const url = this.endpoints.buildUrl('getDeliveryDetails', {
      queryParams :  {userId}});
    return this.httpClient.get(url);
  }
}
